import React from "react";
import { useParams } from "react-router-dom";
import PartyForm from "./PartyForm";

export default function SellerDetails() {
  const { sellerId } = useParams();
  return <PartyForm key={sellerId} type="seller" recordId={sellerId} />;
}
